import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import api from "@/services/api";
import Loader from "@/components/Loader";
import Boolean from "../components/Boolean";
import SingleSelect from "../components/SingleSelect";
import MultiSelect from "../components/MultiSelect";
import toast from "react-hot-toast";

const OfferLaunch = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const [questions, setQuestions] = useState();
  const [values, setValues] = useState();

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const res = await api.post("/question/search", { limit: 300, startup: true });
        if (res.ok) {
          setQuestions(res.data);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchQuestions();

    const fetchData = async () => {
      try {
        const res = await api.get(`/company/${id}`);
        if (res.ok) {
          if (!res.data.plan) res.data.plan = "certified";
          setValues(res.data);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchData();
  }, [id]);

  const handleChange = async () => {
    try {
      const res = await api.put(`/company/${id}`, values);
      if (!res.ok) throw new Error("Une erreur s'est produite lors de la mise à jour de la valeur");
      toast.success("Valeur mise à jour avec succès");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleNext = async () => {
    await handleChange();
    navigate(`../form-offer-monetization`);
  };

  if (!values) return <Loader />;

  return (
    <div className="w-full space-y-8 px-40">
      <MultiSelect question={questions?.find((q) => q.key === "main_clients")} values={values} setValues={setValues} />
      <Boolean question={questions?.find((q) => q.key === "has_customer_reference")} values={values} setValues={setValues} />

      {values.has_customer_reference && (
        <div>
          <label className="block text-gray-700 text-sm font-bold mb-2">
            {t("lable.indicate_references")}
            <span className="ml-2 text-red-500">*</span>
          </label>
          <input
            className="input"
            placeholder={t("placeholder_enter")}
            value={values?.reference_names || ""}
            onChange={(e) => setValues((prev) => ({ ...prev, reference_names: e.target.value }))}
          />
        </div>
      )}

      <SingleSelect question={questions?.find((q) => q.key === "main_business_model")} values={values} setValues={setValues} />
      <MultiSelect question={questions?.find((q) => q.key === "business_models")} values={values} setValues={setValues} />
      <SingleSelect question={questions?.find((q) => q.key === "offer_dev_stage")} values={values} setValues={setValues} />
      <Boolean question={questions?.find((q) => q.key === "user_testing_phase")} values={values} setValues={setValues} />

      {values.user_testing_phase && (
        <div>
          <label className="block text-gray-700 text-sm font-bold mb-2">
            {t("lable.what_type_of_user_testing")}
            <span className="ml-2 text-red-500">*</span>
          </label>
          <input
            className="input"
            placeholder={t("placeholder_enter")}
            value={values?.user_testing_types || ""}
            onChange={(e) => setValues((prev) => ({ ...prev, user_testing_types: e.target.value }))}
          />
        </div>
      )}

      <div className="flex justify-between w-full">
        <Link to={`../form-offer-competition`} className="empty-button disabled:hover:bg-white px-10">
          {t("previous")}
        </Link>
        <div className="flex items-center gap-2">
          <button className="empty-button disabled:hover:bg-white px-10" onClick={handleChange}>
            {t("save")}
          </button>
          <button className="primary-button disabled:hover:bg-white px-10" onClick={handleNext}>
            {t("next")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfferLaunch;
